import { Colors } from "@/enums/Colors";
import { useScrollToTop } from "@/hooks/useScrollToTop";
import { Box, Pagination, paginationItemClasses, PaginationProps, styled } from "@mui/material";

const StyledPagination = styled(Pagination)(() => ({
  [`& .${paginationItemClasses.selected}`]: {
    color: "#fff",
    "&.Mui-selected": {
      backgroundColor: Colors.LAZO_PURPLE,
    },
    "&:hover": {
      backgroundColor: Colors.BUTTON_HOVER_PURPLE,
      color: "#fff",
    },
  },
}));

export const PaginationContainer = styled(Box)(() => ({
  width: "100%",
  marginTop: "auto",
  paddingBlock: "0.5rem",
  display: "flex",
  justifyContent: "flex-end",
  borderTop: `1px solid ${Colors.LIGHT_GRAY_DEDEE1}`,
}));

export interface CommonPaginationProps extends PaginationProps {
  enableScrollToTop?: boolean;
  scrollToTopDelay?: number;
}

function CommonPagination({ enableScrollToTop = true, scrollToTopDelay = 100, ...props }: CommonPaginationProps) {
  const { scrollToTop } = useScrollToTop();

  const handlePageChange = (event: React.ChangeEvent<unknown>, page: number) => {
    // Call the original onChange handler if provided
    if (props.onChange) {
      props.onChange(event, page);
    }

    // Scroll to top after page change
    if (enableScrollToTop) {
      // Small delay to allow content to update before scrolling
      setTimeout(() => {
        scrollToTop();
      }, scrollToTopDelay);
    }
  };

  return <StyledPagination {...props} onChange={handlePageChange} />;
}

export default CommonPagination;
